import { Typography } from '@mui/material';
import React from 'react';

const CopyRight = () => {
    return (
        <div style={{ height: "50px" }}>
            <div style={{ marginTop: '5%' }}>
                <Typography variant="body2" color="white" align="left">
                    © {new Date().getFullYear()} MyBali Rent Car | Rent Car and Bike in Bali
                </Typography>
            </div>
        </div>
    );
};

export default CopyRight;